<template>
  <div class="login">
    <div class="col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3 mx-auto">
        <b-card :title="$t('reg')"
                class="text-center ">

              <form v-on:change="validate()" v-on:submit.prevent="register()" novalidate class="is-invalid">
               <div class="form-group field-login-form-last_name">
                <label class="control-label">{{ $t('family') }}</label>
                <input v-model="data.body.last_name" type="text" class="form-control" v-bind:class="{ 'is-invalid': errors['last_name']  }" required>
                  <div class="invalid-feedback" v-show="errors['last_name']">{{ errors['last_name'] }}</div>
                  <div class="help-block"></div>
              </div>
              <div class="form-group field-login-form-name">
                <label class="control-label">{{ $t('name') }}</label>
                <input v-model="data.body.name" type="text" class="form-control" v-bind:class="{ 'is-invalid': errors['name']  }" required>
                  <div class="invalid-feedback" v-show="errors['name']">{{ errors['name'] }}</div>
                  <div class="help-block"></div>
              </div>
              <div class="form-group field-login-form-second_name">
                <label class="control-label">Отчество</label>
                <input v-model="data.body.second_name" type="text" class="form-control" v-bind:class="{ 'is-invalid': errors['second_name']  }" required>
                  <div class="invalid-feedback" v-show="errors['second_name']">{{ errors['second_name'] }}</div>
                  <div class="help-block"></div>
              </div>
              <div class="form-group field-login-form-email">
                <label class="control-label">{{ $t('mail') }}</label>
                <input type="text" class="form-control" v-model="data.body.email" required  v-bind:class="{ 'is-invalid': errors['email']  }">
                <div class="invalid-feedback" v-show="errors['email']">{{ errors['email'] }}</div>
                  <div class="help-block"></div>
              </div>
              <div class="form-group field-login-form-password">
                <label class="control-label">{{ $t('pass') }}</label>
                <input v-model="data.body.password" type="password" class="form-control" v-bind:class="{ 'is-invalid': errors['password']  }" required>
                  <div class="invalid-feedback" v-show="errors['password']">{{ errors['password'] }}</div>
                  <div class="help-block"></div>
              </div>
              <div class="form-group field-login-form-password">
                <label class="control-label">{{ $t('passaga') }}</label>
                <input v-model="data.body.password2" type="password" class="form-control" v-bind:class="{ 'is-invalid': errors['password']  }" required>
                   <div class="invalid-feedback" v-show="errors['password']">{{ errors['password'] }}</div>
                  <div class="help-block"></div>
              </div>

                  <b-form-checkbox id="agreemnt"
                                   v-model="agreemnt"
                                   :value="true"
                                   :unchecked-value="false" >
                    {{ $t('agre') }}  <a v-b-modal.modal1 href="#">{{ $t('agrem') }}</a>
                  </b-form-checkbox>

                 <b-form-checkbox id="agreemnt2"
                                  v-model="agreemnt2"
                                  :value="true"
                                  :unchecked-value="false">
                   {{ $t('agree') }}  <a v-b-modal.modal2 href="#">{{ $t('agrems') }}</a>
                 </b-form-checkbox>
              <button :disabled="!agreemnt || !agreemnt2"  type="submit" class="btn btn-primary btn-block">{{ $t('doreg') }}</button>
            </form>
        </b-card>

        <p class="text-center">
          <router-link to="/forgot" class="btn btn-sm m-2">{{ $t('forg') }}</router-link>
          <router-link v-if="1!==1" to="/resend" class="btn btn-sm m-2">{{ $t('non') }}</router-link>
          <router-link to="/login" class="btn btn-sm btn-success">{{ $t('alrreg') }}</router-link>
        </p>
      </div>
      <b-modal id="success" ref="success_registration" title="Успешная регистрация">
       <p class="my-4">{{ $t('cre') }}</p>
        <div slot="modal-footer" class="w-100">
         <b-btn size="sm" class="float-right" variant="primary" v-on:click="finish()">
           {{ $t('ok') }}
         </b-btn>
       </div>
     </b-modal>

      <!-- Modal Component -->
  <b-modal id="modal1" size="lg" hide-footer title="Пользовательское соглашение">
    <agreement></agreement>
  </b-modal>

    <b-modal id="modal2" size="lg" hide-footer title="Согласие на обработку персональных данных (ФЗ-152)">
      <agreement_153></agreement_153>
    </b-modal>

    </div>


</template>


<i18n>
{
  "en": {
    "reg": "Registration",
    "login": "Login",
    "mail": "E-mail",
    "pass": "Enter password",
    "passaga": "Confirm the password",
    "family": "Last name",
    "name": "First name",
    "agre": "I agree with the conditions of",
    "agrem": "user agreement",
    "doreg": "Sign up",
    "forg": "Forgot your password?",
    "non": "Did not receive the letter?",
    "alrreg": "Already registered? Log in!",
    "cre": "Your account has been successfully created! Activation instructions sent to your e-mail",
    "ok": "Ok"

  },
  "ru": {
    "reg": "Регистрация",
    "login": "Имя пользователя",
    "mail": "Адрес электронной почты (e-mail)",
    "pass": "Введите пароль",
    "passaga": "Подтвердите пароль",
    "family": "Фамилия",
    "name": "Имя",
    "agre": "Я согласен с условиями",
    "agree": "Я даю согласие на",
    "agrem": "пользовательского соглашения",
    "agrems": "обработку персональных данных",
    "doreg": "Зарегистрироваться",
    "forg": "Забыли пароль?",
    "non": "Не пришло письмо?",
    "alrreg": "Уже зарегистрированы? Войдите!",
    "cre": "Ваш аккаунт успешно создан! Инструкция по активации выслана на ваш e-mail",
    "ok": "Ok"

   }
}
</i18n>


<script>
  import axios from 'axios'
  import agreement from '../../pages/agreement.vue'
  import Agreement_153 from "@/pages/agreement_153";
  export default {
          components:{
            Agreement_153,
              agreement
          },
    data () {
      return {
        agreemnt:false,
        agreemnt2:false,
        context: 'register context',
        errors: [],
        data: {
          body: {
            username: '',
            password: '',
            password2: '',
            email: '',
            phone: '',
            last_name: '',
            name: ''
          },
          autoLogin: false,
          rememberMe: false
        },
        sended: false,
        error: null
      }
    },

    methods: {
      validate () {
        if (this.sended === true) {
          this.$http.put('auth/register?validate=true', {
            'register-form': this.data.body // Axios
          })
          .then(response => {
            // JSON responses are automatically parsed.
            // this.errors = response.data.errors
            if (response.data.errors) {
              this.errors = []
              for (var prop in response.data.errors) {
                var key = prop.replace('register-form-', '')
                this.errors[key] = response.data.errors[prop][0]
              }
            }
          })
        }
      },
      finish () {
        this.$router.push('/login')
      },
      register () {
        if (this.data.body.password !== this.data.body.password2) {
          alert('Введенные вами пароли не совпадают')
          return false;
        }

        this.$auth.register({
          data: {'register-form': this.data.body}, // Axios
          success: function () {
            this.$refs.success_registration.show()
            return false
          },
          error: function (error) {
            if (error.response.data.errors) {
              this.sended = true
              this.errors = []
              for (var prop in error.response.data.errors) {
                var key = prop.replace('register-form-', '')
                this.errors[key] = error.response.data.errors[prop][0]
              }
            }
          },
          redirect: null
        })
      }
    }
  }
</script>
